export default "__VITE_ASSET__TBdYNPuH__"